export const FavouriteNoResult = {
  bindings: {
    isLoading: '<',
    isFavourite: '<',
    onClick: '&',
  },

  template: `
    <div class="favourite-no-results card rounded text-center py-3 px-4 mb-5">
      <i class="fa fa-3x icon-favourites text-pink-cz-mid"></i>
      <h4 class="text-gray">
        <span ng-show="$ctrl.isLoading">
          <spinner is-loading="true"></spinner>
          Loading favourites...
        </span>
        <span ng-hide="$ctrl.isLoading">
          You don't have any favourites
        </span>
      </h4>
      <p class="mb-1" ng-hide="$ctrl.isLoading">
        Items that you have selected as your favourite will appear
        in this list.
      </p>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Favourite/FavouriteNoResult.js